// extracted by mini-css-extract-plugin
export default {"root":"IconChip_root__GihIA","size-small":"IconChip_size-small__P08qK","size-medium":"IconChip_size-medium__cIeof","size-big":"IconChip_size-big__YzX-W"};